/**
 * Export loadData calls from ducks modules of different containers
 */
import {
  loadData as CheckoutPageLoader,
  setInitialValues as CheckoutPageInitialValues,
} from './CheckoutPage/CheckoutPage.duck';
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as CalendarPageLoader } from './CalendarPage/CalendarPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as MessagesPageLoader } from './MessagesPage/MessagesPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as PromotionsPageLoader } from './PromotionsPage/PromotionsPage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import {loadData as SeoPageLoader} from './SeoPage/SeoPage.duck';
import { loadData as AdminVouchersPageLoader } from './AdminVouchersPage/AdminVouchersPage.duck';
import { loadData as AdminAssignmentsPageLoader } from './AdminAssignmentsPage/AdminAssignmentsPage.duck';
import { loadData as WelfarePageLoader } from './WelfarePage/WelfarePage.duck';
import { loadData as CompanyDashboardPageLoader } from './CompanyDashboardPage/CompanyDashboardPage.duck';
import { loadData as WelfareIndexPageLoader } from './WelfareIndexPage/WelfareIndexPage.duck';
import { loadData as AccountWelfarePageLoader } from './AccountWelfarePage/AccountWelfarePage.duck';
import { loadData as PartnerLandingPageLoader } from './PartnerLandingPage/PartnerLandingPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      loadData: CheckoutPageLoader,
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    CalendarPage: {
      loadData: CalendarPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    MessagesPage: {
      loadData: MessagesPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    PromotionsPage: {
      loadData: PromotionsPageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    SeoPage: {
      loadData: SeoPageLoader,
    },
    AdminVouchersPage: {
      loadData: AdminVouchersPageLoader,
    },
    AdminAssignmentsPage: {
      loadData: AdminAssignmentsPageLoader,
    },
    WelfarePage: {
      loadData: WelfarePageLoader,
    },
    CompanyDashboardPage: {
      loadData: CompanyDashboardPageLoader,
    },
    WelfareIndexPage: {
      loadData: WelfareIndexPageLoader,
    },
    AccountWelfarePage: {
      loadData: AccountWelfarePageLoader,
    },
    PartnerLandingPage: {
      loadData: PartnerLandingPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
